"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _socket = _interopRequireDefault(require("socket.io-client"));

var _getstats = _interopRequireDefault(require("getstats"));

var _cache = _interopRequireDefault(require("../util/cache"));

var Log = _interopRequireWildcard(require("../util/Log"));

var _Media = _interopRequireDefault(require("../util/Media"));

var _Device = _interopRequireDefault(require("../Device"));

var DataSync = _interopRequireWildcard(require("../util/DataSync"));

var _constants = require("../util/constants");

require("core-js/fn/array/find");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DtlsSrtpKeyAgreement = {
  DtlsSrtpKeyAgreement: true
};

var sdpConstraints = function sdpConstraints(receive) {
  return {
    OfferToReceiveAudio: receive,
    OfferToReceiveVideo: receive
  };
};
/**
 * ICE connection status : disconnected
 * @constant
 * @type {string}
 */


var ICE_CONNECTION_STATE_DISCONNECTED = 'disconnected';
/**
 * ICE connection status : connected
 * @constant
 * @type {string}
 */

var ICE_CONNECTION_STATE_CONNECTED = 'connected';
/**
 * ICE connection status : completed
 * @constant
 * @type {string}
 */

var ICE_CONNECTION_STATE_COMPLETED = 'completed';
/**
 * ICE connection status : checking
 * @constant
 * @type {string}
 */

var ICE_CONNECTION_STATE_CHECKING = 'checking';
/**
 * ICE connection status : closed
 * @constant
 * @type {string}
 */

var ICE_CONNECTION_STATE_CLOSED = 'closed';
/**
 * ICE connection status : failed
 * @constant
 * @type {string}
 */

var ICE_CONNECTION_STATE_FAILED = 'failed';
/**
 * ICE connection status : another status
 * @constant
 * @type {string}
 */

var ICE_CONNECTION_STATE_OTHER = 'other';
/**
 * @ignore
 */

var _toJSON = function _toJSON(o) {
  return o.toJSON && typeof o.toJSON === 'function' ? o.toJSON() : o;
};
/**
 * The PeerConnection. A PeerConnection will only concern one MediaStream.
 * @class PeerConnection
 */


var PeerConnection =
/*#__PURE__*/
function () {
  /**
   * @access protected
   * @param {string} stackId The WebRTC stack ID
   * @param {string} streamId The Stream UID
   * @param {Remote|{to: string|from: string, device:string}} remote The remote information
   * @param {boolean} publish Publish or Subscribe ?
   */
  function PeerConnection(stackId, streamId, remote, publish) {
    var _this = this;

    _classCallCheck(this, PeerConnection);

    /**
     * The stack identifier. Used to identify exchanges between 2 devices
     * @type {string}
     */
    this.stackId = stackId;
    /**
     * The stream id. (One stream per RTCPeerConnection)
     * @type {string}
     */

    this.streamId = streamId;
    /**
     * The remote device
     * @type {string}
     */

    this.remote = remote;
    /**
     * publish : a created peer connection or a remote one
     * @type {boolean}
     */

    this.publish = publish;
    /**
     * Path for local signalization
     * @access private
     * @type {string}
     */

    this._localPath = "_/webrtc/".concat(this.stackId, "/").concat(this.streamId, "/").concat(_cache.default.device);
    /**
     * Path for local signalization
     * @access private
     * @type {string}
     */

    this._remotePath = "_/webrtc/".concat(this.stackId, "/").concat(this.streamId, "/").concat(this.remote.device);
    /**
     * Indicates if the PeerConnection has been established. (Useful for renegotiation).
     * @type {boolean}
     */

    this.negotiated = false;
    /**
     * The DOM element where the remote MediaStream will be displayed
     * @type {Element}
     * @protected
     */

    this.node = null;
    /**
     * The DOM element containg the media element
     * @type {Element}
     * @protected
     */

    this.container = null;
    /**
     * The actual RTCPeerConnection
     * @type {RTCPeerConnection}
     */

    this.pc = new RTCPeerConnection({
      iceServers: _cache.default.config.iceServers
    }, {
      optional: [DtlsSrtpKeyAgreement],
      mandatory: sdpConstraints(!publish)
    }); // Handle ICE candidates

    this.pc.onicecandidate = function (e) {
      if (!_this.negotiated && e.candidate) {
        Log.d('PeerConnection~onicecandidate', e.candidate);
        DataSync.push("".concat(_this._localPath, "/ice"), _toJSON(e.candidate));
      }
    };

    this.pc.oniceconnectionstatechange = function () {
      Log.d('PeerConnection~oniceconnectionstatechange', _this.pc);
      var iceConnectionState = _this.pc.iceConnectionState;

      switch (iceConnectionState) {
        case ICE_CONNECTION_STATE_CHECKING:
          // Nothing to do yet
          break;

        case ICE_CONNECTION_STATE_CONNECTED:
          _this._attachStream();

          _this._remoteICECandidates(false);

          _this._getStats();

          break;

        case ICE_CONNECTION_STATE_COMPLETED:
          _this._remoteICECandidates(false);

          break;

        case ICE_CONNECTION_STATE_FAILED:
          Log.e('PeerConnection~stateFailed', 'Failed PeerConnection');
          break;

        case ICE_CONNECTION_STATE_DISCONNECTED:
          Log.e('PeerConnection~stateDisconnected', 'Disconnect PeerConnection');
          break;

        case ICE_CONNECTION_STATE_CLOSED:
          Log.d('PeerConnection~stateclosed', 'Close PeerConnection');

          _this.close();

          break;

        default:
          break;
      }

      _this.negotiated = _this.negotiated || _this.isConnected;
    };

    this.pc.onicegatheringstatechange = function () {
      Log.d('PeerConnection~onicegatheringstatechange', _this.pc.iceGatheringState);
    };
    /**
     * PeerConnection status
     * @type {string}
     * @private
     */


    this._status = _constants.OPENED;
  }

  _createClass(PeerConnection, [{
    key: "_getStats",
    value: function _getStats() {
      var _this2 = this;

      Log.d('PeerConnection~getStats', "enable : ".concat(_cache.default.config.stats.server && _cache.default.config.stats.interval ? "to ".concat(_cache.default.config.stats.server) : 'false'));

      if (_cache.default.config.stats.server && _cache.default.config.stats.interval) {
        // this._socket = SocketIO(cache.config.stats.server);
        (0, _getstats.default)(this.pc, function (result) {
          _this2.socket.emit('stats', Object.assign({
            id: _this2.streamId,
            publish: _this2.publish,
            room: _cache.default.room.name,
            ts: new Date(),
            local: _cache.default.device,
            remote: _this2.remote.device
          }, result));
        }, _cache.default.config.stats.interval);
      }
    }
  }, {
    key: "_remoteICECandidates",

    /**
     * Toggle ICE Candidates discovery
     * @access private
     * @param {boolean} listen Indicates if we should listen to new ICE candidates
     */
    value: function _remoteICECandidates(listen) {
      var _this3 = this;

      var path = "".concat(this._remotePath, "/ice");
      var event = 'child_added';

      if (listen) {
        // don't listen to ice candidates if pc is already up (renegotiation)
        DataSync.on(path, event, function (snap) {
          var candidate = snap.val();
          Log.d('PeerConnection~addIceCandidate', candidate);

          _this3.pc.addIceCandidate(new RTCIceCandidate(candidate));
        });
      } else {
        DataSync.off(path, event);
      }
    }
    /**
     * Attach the remote MediaStream to a node
     * @access private
     */

  }, {
    key: "_attachStream",
    value: function _attachStream() {
      if (this.remoteStream && this.isConnected) {
        this.node = _Media.default.attachStream(this.remoteStream, this.container, this.node);
        this.node.muted = false;
      }
    }
    /**
     * The remote MediaStream
     * @access protected
     * @type {MediaStream}
     */

  }, {
    key: "answer",

    /**
     * Init RTCPeerConnection for subscribers
     * @access protected
     * @param htmlElement
     * @param errorCallbacks
     * @returns {Promise.<PeerConnection>}
     */
    value: function answer(htmlElement) {
      var _this4 = this;

      var errorCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      Log.i('PeerConnection~answer', {
        htmlElement: htmlElement,
        peerConnection: this
      });
      this.container = htmlElement;

      if (Object.getOwnPropertyDescriptor(RTCPeerConnection.prototype, 'ontrack')) {
        this.pc.ontrack = function (e) {
          Log.d('PeerConnection~ontrack', e.streams[0]);
          _this4.remoteStream = e.streams[0]; // eslint-disable-line prefer-destructuring
        };
      } else {
        this.pc.onaddstream = function (e) {
          Log.d('PeerConnection~onaddstream', e.stream);
          _this4.remoteStream = e.stream;
        };
      } // Listen to SDP offer


      DataSync.on("".concat(this._remotePath, "/sdp"), 'value', function (snap) {
        var sdpOffer = snap.val(); // Log.d('Offer', sdpOffer);

        if (sdpOffer != null) {
          Log.d("PeerConnection~offered ".concat(sdpOffer.sdp));

          _this4.pc.setRemoteDescription(sdpOffer).catch(function (e) {
            Log.e('PeerConnection~answer#remoteDescription Error', e);
            errorCallbacks.forEach(function (cb) {
              Log.d('PeerConnection~answer#remoteDescription Error callback', e);
              cb(e);
            });
            return e; // cache.peerConnections.close(this.streamId, this.remote.device);
          }).then(function () {
            return Log.d('PeerConnection~answer#remoteDescription', _this4.pc.remoteDescription.sdp);
          }).then(function () {
            if (/^offer$/.test(_this4.pc.remoteDescription.type)) {
              return _this4.pc.createAnswer().catch(function (e) {
                return Log.d.bind(Log, 'PeerConnections~answer#createAnswer', e);
              });
            }

            return Promise.reject(new Error('SDP is not an offer'));
          }).then(function (description) {
            return _this4._setPreferredCodecs(description);
          }).then(function (description) {
            return _this4.pc.setLocalDescription(description);
          }).catch(function (e) {
            return Log.d.bind(Log, 'PeerConnections~answer#setLocalDescription', e);
          }).then(function () {
            Log.d('PeerConnection~answer#localSDP', _this4.pc.localDescription.sdp);

            _this4._remoteICECandidates(true);
          }).then(function () {
            return _this4._sendSdpToRemote();
          }) // .catch(Log.r('PeerConnection~answser#error'));
          .catch(function () {
            // this.close();
            _cache.default.peerConnections.close(_this4.streamId, _this4.remote.device);
          });
        }
      });
      return Promise.resolve(this);
    }
    /**
     * Init RTCPeerConnection for publishers
     * @access protected
     * @param stream
     * @param errorCallbacks
     * @returns {Promise.<PeerConnection>}
     */

  }, {
    key: "offer",
    value: function offer(stream) {
      var _this5 = this;

      var errorCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      Log.i('PeerConnection~offer', {
        stream: stream,
        peerConnection: this
      });
      var sendTimeout;
      return new Promise(function (resolve, reject) {
        _this5.pc.onnegotiationneeded = function () {
          Log.d('PeerConnection~onnegotiationneeded'); // Debounce send (renegotiation triggers multiple negotiationneeded events)

          if (sendTimeout) {
            clearTimeout(sendTimeout);
            sendTimeout = null;
          }

          sendTimeout = setTimeout(function () {
            sendTimeout = null;

            _this5._sendOffer().catch(function (e) {
              Log.d('PeerConnection~offer', e);
              errorCallbacks.forEach(function (cb) {
                return cb(e);
              });
              reject(e);
            }).then(function () {
              resolve(_this5);
            });
          }, 20);
        };

        DataSync.on("".concat(_this5._remotePath, "/sdp"), 'value', function (snap) {
          var sdpAnswer = snap.val();

          if (sdpAnswer != null) {
            Log.d("PeerConnection~offer#answered ".concat(sdpAnswer.sdp));

            _this5.pc.setRemoteDescription(sdpAnswer).catch(function (e) {
              errorCallbacks.forEach(function (cb) {
                return cb(e);
              });

              _cache.default.peerConnections.close(_this5.streamId, _this5.remote.device);

              Log.e.bind(Log, 'PeerConnection~offer#remoteDescription');
            }).then(function () {
              Log.d('PeerConnection~offer#remoteDescription', _this5.pc.remoteDescription.sdp);

              _this5._remoteICECandidates(true);
            });
          }
        });

        _this5._alterStream(stream, 'add');
      });
    }
    /**
     * Send SDP offer to the remote via DataSync
     * @private
     */

  }, {
    key: "_sendSdpToRemote",
    value: function _sendSdpToRemote() {
      var _this6 = this;

      // Log.d('PeerConnection~_sendSdpToRemote#localSDP', this.pc.localDescription.sdp);
      var remoteUserId = this.remote.to ? this.remote.to : this.remote.from;

      _Device.default.get(remoteUserId, this.remote.device).then(function (remoteDevice) {
        var sdpOffer = _this6.pc.localDescription.sdp;
        var newSdp = sdpOffer;
        var local = /Chrome\/([0-9]+)/.exec(navigator.userAgent);
        var remote = /Chrome\/([0-9]+)/.exec(remoteDevice.userAgent);

        if (navigator.userAgent.indexOf('Chrome') !== -1 && navigator.userAgent.indexOf('Android') !== -1 && remoteDevice.userAgent.indexOf('Safari') !== -1 && local[1] <= 64) {
          if (local[1] <= 60) {
            newSdp = newSdp.replace(/;profile-level-id=([a-z0-9]+)/, '');
          } else {
            newSdp = newSdp.replace('42001f', '42e01f');
          }
        }

        if (navigator.userAgent.indexOf('Safari') !== -1 && remoteDevice.userAgent.indexOf('Chrome') !== -1 && remoteDevice.userAgent.indexOf('Android') !== -1 && remote[1] <= 64) {
          if (remote[1] <= 60) {
            newSdp = newSdp.replace(/;profile-level-id=([a-z0-9]+)/, '');
          } else {
            newSdp = newSdp.replace('42e01f', '42001f');
          }
        }

        Log.d("PeerConnection~_sendSdpToRemote#SDP sent to remote ".concat(newSdp));
        var descriptionChanged = {
          sdp: newSdp,
          type: _this6.pc.localDescription.type
        };
        DataSync.update("".concat(_this6._localPath, "/sdp"), _toJSON(descriptionChanged));
      });
    }
    /**
     * Create SDP offer and push it
     * @returns {Promise}
     * @private
     */

  }, {
    key: "_sendOffer",
    value: function _sendOffer() {
      var _this7 = this;

      Log.d('PeerConnection~_sendOffer');
      return this.pc.createOffer().then(function (description) {
        return _this7._setPreferredCodecs(description);
      }).then(function (description) {
        return _this7.pc.setLocalDescription(description);
      }).then(function () {
        return Log.d('PeerConnection~_sendOffer#localDescription', _this7.pc.localDescription.sdp);
      }).then(function () {
        return _this7._sendSdpToRemote();
      });
    }
    /**
     * Add/Remove tracks to the PeerConnection stream
     * @param {MediaStream} stream
     * @param {string} method
     * @private
     */

  }, {
    key: "_alterStream",
    value: function _alterStream(stream, method) {
      var _this8 = this;

      if (Object.getOwnPropertyDescriptor(RTCPeerConnection.prototype, "".concat(method, "Track"))) {
        if (method === 'add') {
          stream.getTracks().forEach(function (track) {
            return _this8.pc["".concat(method, "Track")](track, stream);
          }, this);
        } else {
          this.pc.getSenders().forEach(function (sender) {
            return _this8.pc["".concat(method, "Track")](sender);
          }, this);
        }
      } else {
        this.pc["".concat(method, "Stream")](stream);
      }
    }
    /**
     * Restart SDP negotiation following a MediaStream change
     * @access protected
     * @param {MediaStream} oldStream
     * @param {MediaStream} newStream
     */

  }, {
    key: "renegotiate",
    value: function renegotiate(oldStream, newStream) {
      Log.d('PeerConnection~renegotiate');

      if (Object.getOwnPropertyDescriptor(RTCPeerConnection.prototype, 'getSenders') && 'RTCRtpSender' in window && Object.getOwnPropertyDescriptor(RTCRtpSender.prototype, 'replaceTrack')) {
        // mozRTCPeerConnection implementation
        this.pc.getSenders().forEach(function (sender) {
          var newTracks;

          switch (sender.track.kind) {
            case 'audio':
              newTracks = newStream.getAudioTracks();
              break;

            case 'video':
              newTracks = newStream.getVideoTracks();
              break;

            default:
              newTracks = [];
          }

          if (newTracks.length) {
            sender.replaceTrack(newTracks[0]);
          }
        });

        this._sendOffer().catch(function (e) {
          Log.d('PeerConnection~renegotiate', e);
        });
      } else {
        this._alterStream(oldStream, 'remove');

        this._alterStream(newStream, 'add');
      }
    }
    /**
     * Close the PeerConnection and stop listening to SDP messages
     * @access protected
     */

  }, {
    key: "close",
    value: function close() {
      var _this9 = this;

      if (this._status === _constants.OPENED) {
        this._status = _constants.CLOSING; // Stop display

        if (this.node) {
          if (this.node.stop) {
            this.node.stop();
          }

          this.node.srcObject = null;
          this.container.removeChild(this.node);
          this.node = null;
        } // Stop listening to remote ICE candidates


        this._remoteICECandidates(false); // Stop listening to SDP messages


        DataSync.off("".concat(this._remotePath, "/sdp"), 'value'); // Remove data

        DataSync.remove(this._localPath); // Close PeerConnection

        if (this.pc && this.pc.signalingState !== 'closed') {
          this.pc.onsignalingstatechange = function () {
            if (_this9.pc.signalingState !== 'closed') {
              _this9._status = _constants.CLOSED;
            }
          };

          this.pc.close();
        } else {
          this._status = _constants.CLOSED;
        }
      }
    }
    /**
     * Edits the SDP to set the preferred audio/video codec
     * @access private
     * @param {RTCSessionDescription} description
     * The description retrieved by createOffer/createAnswer
     * @returns {RTCSessionDescription|{sdp: string, type: string}}
     */

  }, {
    key: "_setPreferredCodecs",
    value: function _setPreferredCodecs(description) {
      if (_cache.default.config.preferredVideoCodec || _cache.default.config.preferredAudioCodec) {
        Log.d('PeerConnection~_setPreferredCodecs', {
          description: description,
          config: _cache.default.config
        });
        var sdpLines = description.sdp.split(/\r?\n/);
        var medias = {
          audio: [],
          video: []
        };
        var current = null; // Parse SDP

        sdpLines.forEach(function (sdpLine, i) {
          if (/^m=/.test(sdpLine)) {
            // eslint-disable-next-line no-useless-escape
            var d = /^m=(\w+)\s[0-9\/]+\s[A-Za-z0-9\/]+\s([0-9\s]+)/.exec(sdpLine);
            current = {
              fmt: d[2].split(/\s/),
              index: i,
              codecs: []
            };
            medias[d[1]].push(current);
          } else if (current && /^a=rtpmap:/.test(sdpLine)) {
            // eslint-disable-next-line no-useless-escape
            var c = /^a=rtpmap:(\d+)\s([a-zA-Z0-9\-\/]+)/.exec(sdpLine);

            if (c) {
              current.codecs.push({
                id: c[1],
                name: c[2],
                index: i
              });
            }
          }
        });
        Log.d('PeerConnection~_setPreferredCodecs', medias);
        var update = false;

        var prefer = function prefer(mediaList, preferedCodec) {
          mediaList.forEach(function (media) {
            var selected = media.codecs.find(function (codec) {
              return preferedCodec.test(codec.name);
            });

            if (selected) {
              var fmt = [selected.id].concat(media.fmt.filter(function (ids) {
                return ids !== selected.id;
              }));
              sdpLines[media.index] = sdpLines[media.index].replace(media.fmt.join(' '), fmt.join(' '));
              update = true;
            }
          });
        };

        if (_cache.default.config.preferredVideoCodec) {
          prefer(medias.video, _cache.default.config.preferredVideoCodec);
        }

        if (_cache.default.config.preferredAudioCodec) {
          prefer(medias.audio, _cache.default.config.preferredAudioCodec);
        }

        if (update) {
          Log.d('PeerConnection~_setPreferredCodecs', sdpLines.join('\r\n'));
          return {
            sdp: sdpLines.join('\r\n'),
            type: description.type
          };
        }
      }

      return description;
    }
  }, {
    key: "socket",
    get: function get() {
      if (!this._socket) {
        this._socket = (0, _socket.default)(_cache.default.config.stats.server);
      }

      return this._socket;
    }
  }, {
    key: "remoteStream",
    set: function set(stream) {
      /**
       * @ignore
       */
      this._remoteStream = stream;

      this._attachStream();
    }
    /**
     * The remote MediaStream
     * @type {MediaStream}
     */
    ,
    get: function get() {
      return this._remoteStream;
    }
    /**
     * Indicates if the PeerConnection is established based on ICE connection state
     * @returns {boolean}
     */

  }, {
    key: "isConnected",
    get: function get() {
      return this.pc && !!~[// eslint-disable-line no-bitwise
      ICE_CONNECTION_STATE_CONNECTED, ICE_CONNECTION_STATE_COMPLETED, ICE_CONNECTION_STATE_OTHER].indexOf(this.pc.iceConnectionState);
    }
  }]);

  return PeerConnection;
}();

exports.default = PeerConnection;